/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/reply'
export default icon
